<template>
  <el-dialog title="Edit Service Type" :close-on-click-modal="false" :visible.sync="visible" width="1100px" top="3vh">
    <div class="tableBorder">
      <el-form :model="dataForm" ref="dataForm" autocomplete="off" label-position="top">
        <el-row :gutter="10" class="customTh">
          <el-col :span="4" class="tac">Service Type</el-col>
          <el-col :span="9" class="tac">Service Details</el-col>
          <el-col :span="3" class="tac">Currency</el-col>
          <el-col :span="4" class="tac">Related Transaction</el-col>
          <el-col :span="4" class="tac">Related Turnover</el-col>
        </el-row>

        <div class="customTbody" v-for="(item, index) in dataForm.serviceList" :key="`serviceList${index}`">
          <el-row :gutter="10">
            <el-col :span="4" class="tac">
              <el-form-item>{{ item.serviceType }}</el-form-item>
            </el-col>
            <el-col :span="9" class="tac">
              <el-form-item>
                <span class="enbr">{{ item.serviceDetails.filter(item => item).join(", ") }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item :prop="`serviceList.${index}.currency`" :ref="`serviceList.${index}.currency`">
                <el-select v-model="dataForm.serviceList[index].currency" placeholder="Currency" clearable filterable>
                  <el-option
                    v-for="(item, idx) in currencyList"
                    :key="`currency-${index}-${idx}`"
                    :label="item.currency"
                    :value="item.currency"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item :prop="`serviceList.${index}.relatedTransaction`" :ref="`serviceList.${index}.relatedTransaction`">
                <el-input v-model="dataForm.serviceList[index].relatedTransaction" v-minusPoint2 clearable placeholder="0.00">
                  <template slot="prefix">{{ currencySymbolFormat(dataForm.serviceList[index].currency) }}</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item :prop="`serviceList.${index}.relatedTurnover`" :ref="`serviceList.${index}.relatedTurnover`">
                <el-input v-model="dataForm.serviceList[index].relatedTurnover" v-minusPoint2 clearable placeholder="0.00">
                  <template slot="prefix">{{ currencySymbolFormat(dataForm.serviceList[index].currency) }}</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" @click="dataFormSubmit">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import formatterMixin from "@/mixins/formatterMixin";
import { mapState } from "vuex";
export default {
  mixins: [formatterMixin],
  data() {
    return {
      visible: false,
      dataForm: {
        serviceList: [],
      },
    };
  },
  methods: {
    async init(list) {
      this.visible = true;
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      this.dataForm = {
        serviceList: list,
      };
    },
    // 保存
    dataFormSubmit() {
      this.$refs["dataForm"].validate(async valid => {
        if (valid) {
          const dataForm = JSON.parse(JSON.stringify(this.dataForm));
          this.$emit("serviceTypeFeedback", dataForm.serviceList);
          this.visible = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";
.blue {
  color: $--color-primary;
}

.red {
  color: $--color-danger;
}

.tableBorder {
  .customTh {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    font-weight: bold;
    background-color: #f4f8fe;
    border-bottom: 1px solid #ebeef5;
  }

  .customTbody {
    padding: 16px 0 0;
    border-bottom: 1px solid #ebeef5;
  }
}
</style>
